import * as React from "react"
const HeadIcon = ({
  fill = "currentColor",
  strokeWidth = 0.5,
  strokeColor = "#000",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="\u30EC\u30A4\u30E4\u30FC 2"
    viewBox="0 0 51.5 26.92"
  >
    <path
      d="m37.1 22.73-.02-1.54 13.42-7.86-13.58-7.64-.01-1.49L.5.55v25.82l36.6-3.64z"
      data-name="day mode"
      style={{
        fill: fill,
        stroke: strokeColor,
        strokeWidth: strokeWidth,
        strokeMiterlimit: 10,
      }}
    />
  </svg>
)
export default HeadIcon
